import React from 'react';
import { InstantSearch } from 'react-instantsearch';
import { searchClient } from '../../services/Algolia';
import config from '../../services/Config';
import AlgoliaInsightsMiddleware from '../AlgoliaInsightsMiddleware';
import SearchInput from './SearchInput';

const Search2 = () => {
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={config.algoliaSearchIndex}
    >
      <AlgoliaInsightsMiddleware />
      <SearchInput />
    </InstantSearch>
  );
};

export default Search2;
